import { useNavigate } from "react-router-dom";
import {
  BlueBirdTheme,
  Breadcrumb,
  Button,
  Typography,
} from "@kitbird/core";
import { PageCard, PageWrapper } from "../../../../../components/Content/Content.style";
import { HeaderText } from "../../../../../components/FloatHeader/FloatHeader.style";
import { useUserPosition } from "../../Provider";
import {
  MutationPageGrid,
  ModalBodyWrapper as BodyWrapper,
  ScrollableFormArea as ScrollableArea,
} from "./MutationUser.styled";
import UserPositionInfo from "./UserPositionInfo";
import MutationConfirmationModal from "./MutationConfirmationModal";
import TableCurrentPositions from "./TableCurrentPositions";
import MutationForm from "./MutationForm";

const MutationPage = () => {
  const navigate = useNavigate();
  const {
    user,
    isLoadingUser,
    errorUser,
    sourceUserPositions,
    handleProceedToConfirmation,
    mutationForm,
    isLoadingSourceUserDetail,
  } = useUserPosition();
  const { formState: { isValid } } = mutationForm;

  return (
    <>
      <PageWrapper>
        <HeaderText>
          <Typography level={3} color={BlueBirdTheme.colors.gray.title} fontWeight="medium">
            Mutasi user
          </Typography>
        </HeaderText>
        <Breadcrumb
          items={[
            { title: "Master user", path: "LIST" },
            { title: "Mutasi user" },
          ]}
          onClick={(item) => {
            if (item.path && item.path === "LIST") {
              navigate("/master-data/user-position");
            }
          }}
        />
        <MutationPageGrid>
          <PageCard style={{ height: "80vh" }}>
            <BodyWrapper>
              <ScrollableArea>
                <UserPositionInfo
                  user={user}
                  isError={errorUser}
                  isLoading={isLoadingUser}
                  variant="HISTORY"
                  badge={{
                    show: true,
                    backgroundColor: user?.is_active
                      ? BlueBirdTheme.colors.success[500]
                      : BlueBirdTheme.colors.danger[400],
                    color: BlueBirdTheme.colors.white,
                    label: user?.is_active ? "Aktif" : "Tidak aktif",
                    position: "top-right",
                  }}
                  userPosition={sourceUserPositions}
                />
                <TableCurrentPositions
                  isLoading={isLoadingSourceUserDetail}
                  dataSource={sourceUserPositions}
                  hasPrimaryColor
                />
              </ScrollableArea>
            </BodyWrapper>
          </PageCard>
          <PageCard style={{ height: "80vh" }}>
            <BodyWrapper>
              <ScrollableArea>
                <MutationForm />
              </ScrollableArea>
              <div style={{
                display: "flex",
                gap: "1.5rem",
                justifyContent: "flex-end",
                padding: "1rem",
              }}>
                <Button
                  variant="text"
                  onClick={() => navigate("/master-data/user-position")}
                  style={{ color: BlueBirdTheme.colors.gray.subtitle, minWidth: "130px" }}
                >
                  Kembali
                </Button>
                <Button
                  data-testid="mutation-submit"
                  type="button"
                  onClick={handleProceedToConfirmation}
                  disabled={!isValid}
                  style={{ minWidth: "130px" }}
                >
                  Mutasi
                </Button>
              </div>
            </BodyWrapper>
          </PageCard>
        </MutationPageGrid>
      </PageWrapper>
      <MutationConfirmationModal />
    </>
  );
};

export default MutationPage;
